<template>
  <div>
    <LDBsTable
      url="active"
      defaultSort="activeType"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions='options'
    >
      <div class="form-group col-lg-4">
        <label for="model">{{ $t('model') }}</label>
        <Combobox
          multiple
          class="bg-white"
          name='model'
          :placeholder="$t('select_a_item')"
          label="name"
          :getOptionLabel="model => model.name ? model.manufacturer.name + ' / ' + model.name : ''"
          :options="allModels"
          :initial-value="query.model"
          v-model="query.model"
          :reduce="models => models.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="serie">{{ $t('serie') }}</label>
        <input
          type="text"
          id="serie"
          name="serie"
          class="form-control"
          :placeholder="$t('ph_serie')"
          v-model="query.serie"
          @input="upper('serie')"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="active_type">{{ $t('active_type') }}</label>
        <Combobox
          multiple
          class="bg-white"
          name='actives_type'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="activestypes"
          :initial-value="query.activeType"
          v-model="query.activeType"
          :reduce="activesTypes => activesTypes.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="manufacturer">{{ $t('manufacturer') }}</label>
        <Combobox
          multiple
          class="bg-white"
          name='manufacturer'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="manufacturers"
          :initial-value="query.manufacturer"
          v-model="query.manufacturer"
          :reduce="manufacturers => manufacturers.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="location">{{ $t('location') }}</label>
        <Combobox
          class="bg-white"
          name='location'
          :placeholder="$t('select_a_item')"
          :options="locations"
          v-model="query.location"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="garage_accredited_name">{{ $t('garage_accredited_name') }}</label>
        <Combobox
          :disabled="query.location !== 'OFICINA CREDENCIADA'"
          class="bg-white"
          name='garage_accredited'
          :placeholder="$t('select_a_item')"
          label="fantasyName"
          :options="garages"
          :initial-value="query.garageAccredited"
          :reduce="garage => garage.id"
          v-model="query.garageAccredited"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :options="clients"
          :reduce="client => client.CLI_ID"
          v-model="query.client"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="board">{{ $t('board') }}</label>
        <input
          type="text"
          class="form-control"
          id="board"
          name='board'
          :placeholder="$t('ph_board')"
          v-model="query.board"
          @input="upper('board')"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="status">{{ $t('status') }}</label>
        <Combobox
          class="bg-white"
          name='status'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="status.rows"
          v-model="query.status"
          :reduce="status => status.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="field_extra1">{{ fieldExtraName1 || $t('field_extra') + ' 1' }}</label>
        <input
          type="text"
          id="field_extra1"
          name="field_extra1"
          class="form-control"
          :placeholder="fieldExtraName1 || $t('field_extra') + ' 1'"
          v-model="query.fieldExtra1"
          @input="upper('fieldExtra1')"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="field_extra2">{{ fieldExtraName2 || $t('field_extra') + ' 2' }}</label>
        <input
          type="text"
          id="field_extra2"
          name="field_extra2"
          class="form-control"
          :placeholder="fieldExtraName2 || $t('field_extra') + ' 2'"
          v-model="query.fieldExtra2"
          @input="upper('fieldExtra2')"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="field_extra3">{{ fieldExtraName3 || $t('field_extra') + ' 3' }}</label>
        <input
          type="text"
          id="field_extra3"
          name="field_extra3"
          class="form-control"
          :placeholder="fieldExtraName3 || $t('field_extra') + ' 3'"
          v-model="query.fieldExtra3"
          @input="upper('fieldExtra3')"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="isActive">{{ $t('active') }}</label>
        <Combobox
          class="bg-white"
          name='isActive'
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.isActive"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
          v-model="query.isActive"
          :reduce="active => active.value"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="activesNoLinked">{{ $t('trackerAndSimCardNoLinked') }}</label>
        <Combobox
          class="bg-white"
          name='activesNoLinked'
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.activesNoLinked"
          :options="[{ label: 'SIM', value: true }]"
          v-model="query.activesNoLinked"
          :reduce="activeNoLinked => activeNoLinked.value"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="np">NP</label>
        <Combobox
          :disabled="disableNP"
          class="bg-white"
          name='np'
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.np"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          v-model="query.np"
          :reduce="np => np.value"
        />
      </div>
    </LDBsTable>

    <!-- MODAL INFO LINKED ACTIVE -->
    <div
      ref='modalInfo'
      id="modalInfo"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalInfo"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalInfoLabel">Informações ativo vinculado {{ active && `(${active.activeTypeData.name})` }}</h5>
          </div>

          <div class="modal-body">
            <b-list-group v-if="active">
              <b-list-group-item>Fabricante: {{ active.model.manufacturer.name }}</b-list-group-item>
              <b-list-group-item>Modelo: {{ active.model.name }}</b-list-group-item>
              <b-list-group-item>Serial: {{ active.serie }}</b-list-group-item>
              <b-list-group-item v-show="active.fieldExtra1">Campo Extra 1: {{ active.fieldExtra1 }}</b-list-group-item>
              <b-list-group-item v-show="active.fieldExtra2">Campo Extra 2: {{ active.fieldExtra2 }}</b-list-group-item>
              <b-list-group-item v-show="active.fieldExtra3">Campo Extra 3: {{ active.fieldExtra3 }}</b-list-group-item>
            </b-list-group>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              <b-spinner small v-show="busy" />
              {{ busy ? $t('loading') + ' ...' : $t('close') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL UNLINK TRACKER AND SIMCARD -->
    <div
      ref='modalUnlinkTrackerAndSimcard'
      id="modalUnlinkTrackerAndSimcard"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalUnlinkTrackerAndSimcard"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalUnlinkTrackerAndSimcardLabel">Desvincular rastreador e simcard</h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <h3>RASTREADOR</h3>
            <h5 v-if="dataToUnlink">{{ dataToUnlink.manufacturer + ' / ' + dataToUnlink.model + ' / ' + dataToUnlink.serie }}</h5>

            <hr>
            <h3>SIMCARD</h3>
            <h5 v-if="active">{{ infoSimcardToUnlink }}</h5>

            <hr>
            <h3>Deseja desvincular os ativos?</h3>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('no') }}
            </b-button>

            <b-button
              class="mt-3"
              :disabled='busy'
              variant="primary"
              @click='unlinkTrackerAndSimcard'
            >
              <b-spinner small v-show="busy" />
              {{ busy ? $t('loading') + ' ...' : $t('yes') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL UNLINK ACTIVE MODEL AND SIMCARD -->
    <div
      ref='modalUnlinkActiveModelAndSimcard'
      id="modalUnlinkActiveModelAndSimcard"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalUnlinkActiveModelAndSimcard"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalUnlinkActiveModelAndSimcardLabel">Desvincular ativo (modelo) e simcard</h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <h3 v-if="dataToUnlink">{{ dataToUnlink.activetypename || 'ATIVO' }}</h3>
            <h5 v-if="dataToUnlink">{{ dataToUnlink.manufacturer + ' / ' + dataToUnlink.model + ' / ' + dataToUnlink.serie }}</h5>

            <hr>
            <h3>SIMCARD</h3>
            <h5 v-if="active">{{ infoSimcardToUnlink }}</h5>

            <hr>
            <h3>Deseja desvincular os ativos?</h3>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('no') }}
            </b-button>

            <b-button
              class="mt-3"
              :disabled='busy'
              variant="primary"
              @click='unlinkActiveModelAndSimcard'
            >
              <b-spinner small v-show="busy" />
              {{ busy ? $t('loading') + ' ...' : $t('yes') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL LOAD LINKED -->
    <div
      ref='modalLoadLinked'
      id="modalLoadLinked"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalLoadLinked"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalLoadLinkedLabel">Carregando...</h5>
          </div>

          <div class="modal-body text-center">
            <b-spinner small v-show="busy" />
          </div>

          <div class="col-12 text-right modal-footer">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import location from '@/config/locations'
import { request } from '@/lib/http'
import axios from 'axios'
import { apiBaseUrl } from '@/lib/config'
import _ from 'lodash'

export default {
  name: 'ActiveList',

  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('active_type'),
          field: 'activeTypeName',
          sortable: true
        },
        {
          title: this.$t('manufacturer'),
          field: 'manufacturerName',
          sortable: true
        },
        {
          title: this.$t('model'),
          field: 'modelName',
          sortable: true
        },
        {
          title: this.$t('serie'),
          field: 'serie',
          sortable: true
        },
        {
          title: this.$t('location'),
          field: 'location',
          sortable: true
        },
        {
          title: this.$t('status'),
          field: 'activeStatusName',
          sortable: true
        },
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccreditedName',
          sortable: true
        },
        {
          title: this.$t('client'),
          field: 'clientName',
        },
        {
          title: this.$t('board'),
          field: 'vehiclePlate',
          width: '100%',
          sortable: true
        },
        {
          title: this.$t('field_extra') + ' 1',
          field: 'fieldExtra1',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('field_extra') + ' 2',
          field: 'fieldExtra2',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('field_extra') + ' 3',
          field: 'fieldExtra3',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('obs'),
          field: 'obs',
          visible: false,
          sortable: true
        },
        {
          title: this.$t('purchase_date'),
          field: 'purchaseDate',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('purchase_value'),
          field: 'purchaseValue',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('warranty_date'),
          field: 'warrantyDate',

          sortable: true,
          visible: false
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('last_movement'),
          field: 'lastMovement',

          visible: false,
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '190px',
          formatter: function (value, row) {
            const activeTypeId = row.activeTypeId

            if (activeTypeId === 6 && row.np) {
              return '-'
            }

            let buttons = `
              <a
                href="#/main/active/${value}"
                title="Editar"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
            `

            const isLinked = row.linked
            const isTracker = activeTypeId === 10
            const isSimcard = activeTypeId === 6

            if (row.modelCanLinkSimcard && !isTracker) {
              buttons += `
                <a
                  style="${isLinked ? 'pointer-events: none;' : ''}"
                  href="#/main/link-active-model-simcard/${value}"
                  title='Vincular ${row.activeTypeName} com SIMCARD'
                  class="edit btn btn-action ${isLinked ? 'btn-secondary' : 'btn-success'} btn-circle light-bottom-shadow text-white"
                >
                  <i class="fas fa-link" />
                </a>
              `
            }

            if (isTracker) {
              buttons += `
                <a
                  style="${isLinked ? 'pointer-events: none;' : ''}"
                  href="#/main/link-tracker-simcard/${value}"
                  title='Vincular RASTREADOR com SIMCARD'
                  class="edit btn btn-action ${isLinked ? 'btn-secondary' : 'btn-success'} btn-circle light-bottom-shadow text-white"
                >
                  <i class="fas fa-link" />
                </a>
              `
            }

            if (isLinked) {
              if (!isSimcard) {
                buttons += `
                  <button
                    title='Desvincular ${row.activeTypeName} e SIMCARD'
                    data-target="${isTracker ? '#modalUnlinkTrackerAndSimcard' : '#modalUnlinkActiveModelAndSimcard'}"
                    data-id='${row.linked}'
                    data-manufacturer='${row.manufacturerName}'
                    data-model='${row.modelName}'
                    data-serie='${row.serie}'
                    data-activetypename='${row.activeTypeName}'
                    data-toggle="modal"
                    class="edit mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white">
                    <i class="fas fa-unlink" />
                  </button>
                `

                buttons += `
                  <button
                    title="Visualizar SIMCARD vinculado"
                    data-target="#modalInfo"
                    data-id='${row.linked}'
                    data-toggle="modal"
                    class="edit mb-1 btn btn-action btn-success btn-circle light-bottom-shadow text-white">
                    <i class="fas fa-info fa-sim-card fa-lg" />
                  </button>
                `
              }


              if (isSimcard) {
                buttons += `
                  <button
                    title="Visualizar ativo vinculado"
                    data-target="#modalInfo"
                    data-id='${row.linked}'
                    data-toggle="modal"
                    class="edit mb-1 btn btn-action btn-success btn-circle light-bottom-shadow text-white">
                    <i class="fas fa-info fa-satellite-dish fa-lg" />
                  </button>
                `
              }

              buttons += `
                <button
                  title="Carregar ativo vinculado"
                  data-target="#modalLoadLinked"
                  data-id='${row.linked}'
                  data-toggle="modal"
                  class="edit mb-1 btn btn-action btn-secondary btn-circle light-bottom-shadow text-white">
                  <i class="fas fa-external-link-alt" />
                </button>
              `
            }

            return buttons
          }
        }
      ],
      options: {
        exportOptions: { fileName: 'ativos' }
      },
      query: {
        id              : '',
        model           : undefined,
        serie           : '',
        manufacturer    : undefined,
        activeType      : undefined,
        isActive        : true,
        location        : '',
        garageAccredited: '',
        fieldExtra1     : '',
        fieldExtra2     : '',
        fieldExtra3     : '',
        status          : '',
        board           : '',
        client          : undefined,
        activesNoLinked : undefined,
        np              : undefined
      },
      locations          : location,
      fieldExtraName1    : undefined,
      fieldExtraName2    : undefined,
      fieldExtraName3    : undefined,
      busy               : false,
      dataToUnlink       : undefined,
      infoSimcardToUnlink: undefined,
      alert: {
        show: false,
        type: 'danger',
        message: 'Erro ao desvincular ativos!'
      },
      clients  : [],
      disableNP: true,
      queryToUse: {}
    }
  },

  watch: {
    'query.location': function(value) {
      if (value !== 'OFICINA CREDENCIADA') this.query.garageAccredited = ''
    },

    'query.activeType': function(value) {
      if (value && value.find(type => type === 6)) {
        this.disableNP = false
      } else {
        this.disableNP = true
        this.query.np  = undefined
      }

      const [activeType] = this.activestypes.filter(activeType => activeType.id === value)

      const formatText = value => value[0] + value.slice(1).toLowerCase()

      if (activeType) {
        this.fieldExtraName1 = activeType.fieldLegend1 ? formatText(activeType.fieldLegend1) : undefined
        this.fieldExtraName2 = activeType.fieldLegend2 ? formatText(activeType.fieldLegend2) : undefined
        this.fieldExtraName3 = activeType.fieldLegend3 ? formatText(activeType.fieldLegend3) : undefined
      } else {
        this.fieldExtraName1 = undefined
        this.fieldExtraName2 = undefined
        this.fieldExtraName3 = undefined
      }
    },

    active: function(value) {
      if (!value) {
        return this.infoSimcardToUnlink = undefined
      }

      let info = `${value.model.manufacturer.name} / ${value.model.name}`

      const fields = ['fieldExtra1', 'fieldExtra2', 'fieldExtra3']

      for (const item of fields) {
        if (value[item]) {
          info += ` / ${value[item]}`
        }
      }

      this.infoSimcardToUnlink = info
    }
  },

  computed: {
    ...mapState({
      manufacturers: state => state.manufacturer.all,
      activestypes: state => state.activestype.all,
      models: state => state.model.all,
      garages: state => state.garageaccredited.all,
      status: state => state.status.all,
      active: state => state.active.activeById,
      lastquery: state => state.filtershistory.query
    }),

    allModels() {
      if (!this.query.activeType || !this.query.activeType.length) {
        return this.models
      }

      return this.models.filter(model => this.query.activeType.includes(model.activeType))
    }
  },

  methods: {
    clear() {
      this.query.model = undefined,
      this.query.serie = '',
      this.query.manufacturer = undefined,
      this.query.activeType = undefined,
      this.query.isActive = true,
      this.query.location = '',
      this.query.garageAccredited = '',
      this.query.board = '',
      this.query.fieldExtra1 = '',
      this.query.fieldExtra2 = '',
      this.query.fieldExtra3 = '',
      this.query.status = '',
      this.query.client = undefined,
      this.query.activesNoLinked = undefined
    },

    async getSimcard(id) {
      this.busy = true

      await this.$store.dispatch('active/fetchById', id)

      this.busy = false
    },

    async unlinkTrackerAndSimcard() {
      this.busy = true
      const { id } = this.dataToUnlink

      try {
        const result = await request({
          url: 'unlink-tracker-simcard',
          method: 'put',
          data: { simcardId: id }
        })
      } catch (error) {
        this.alert.message = error.message === 'activesInVehicle'
          ? 'Ativos estão vinculados a veículo'
          : 'Erro ao desvincular ativos!'

        return this.alert.show = true
      } finally {
        this.busy = false
      }

      $('#modalUnlinkTrackerAndSimcard').modal('hide')
      $('#search').trigger('click')
    },

    async unlinkActiveModelAndSimcard() {
      this.busy = true
      const { id } = this.dataToUnlink

      try {
        const result = await request({
          url: 'unlink-active-model-simcard',
          method: 'put',
          data: { simcardId: id }
        })
      } catch (error) {
        this.alert.message = error.message === 'activesInVehicle'
          ? 'Ativos estão vinculados a veículo'
          : 'Erro ao desvincular ativos!'

        return this.alert.show = true
      } finally {
        this.busy = false
      }

      $('#modalUnlinkActiveModelAndSimcard').modal('hide')
      $('#search').trigger('click')
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase()
    },

    async loadLinked(id) {
      await this.$store.dispatch('active/fetchById', id)

      this.busy = true

      this.clear()

      this.query.serie = this.active.serie

      setTimeout(() => {
        this.busy = false

        $('#modalLoadLinked').modal('hide')
      }, 1000)

      $('#search').trigger('click')
    },

    async exportSpreadsheet() {
      const { dispatch } = this.$store

      try {
        dispatch('overlay/show', true)

        const data = await axios.get(`${apiBaseUrl()}export-actives-csv`, { responseType: 'blob' })

        const url  = window.URL.createObjectURL(new Blob([data.data]))
        const link = document.createElement('a')
        link.href  = url

        const contentDisposition = data.headers['content-disposition'];
        let filename = 'ativos.xlsx';

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (filenameMatch.length > 1) {
            filename = filenameMatch[1];
          }
        }

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        dispatch('notify/error', { message: error }, { root: true })
      } finally {
        dispatch('overlay/show', false)
      }
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['actives'] ? this.lastquery['actives'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store

    try {
      dispatch('overlay/show', true, { root: true })

      await Promise.all([
        dispatch('manufacturer/fetchAll'),
        dispatch('activestype/fetchAll'),
        dispatch('model/fetchAll'),
        dispatch('garageaccredited/fetchAll'),
        dispatch('status/fetchAll')
      ])
      // await dispatch('manufacturer/fetchAll'),
      // await dispatch('activestype/fetchAll'),
      // await dispatch('model/fetchAll'),
      // await dispatch('garageaccredited/fetchAll')
      // await dispatch('status/fetchAll')

      this.clients = await request({
        url: `clients`,
        method: 'get'
      })

      const global = this

      $('#modalInfo').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget)
        const modal = $(this)
        global.getSimcard(button.data('id'))
      })

      $('#modalInfo').on('hide.bs.modal', function (event) {
        global.$store.dispatch('active/cleanState')
      })

      $('#modalUnlinkTrackerAndSimcard').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget)
        const modal = $(this)
        global.getSimcard(button.data('id'))
        global.dataToUnlink = {
          id: button.data('id'),
          manufacturer: button.data('manufacturer'),
          model: button.data('model'),
          serie: button.data('serie'),
          activetypename: button.data('activetypename'),
        }
      })

      $('#modalUnlinkTrackerAndSimcard').on('hide.bs.modal', function (event) {
        global.dataToUnlink = undefined
        global.$store.dispatch('active/cleanState')
        global.alert.show = false
      })

      $('#modalUnlinkActiveModelAndSimcard').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget)
        const modal = $(this)
        global.getSimcard(button.data('id'))
        global.dataToUnlink = {
          id: button.data('id'),
          manufacturer: button.data('manufacturer'),
          model: button.data('model'),
          serie: button.data('serie'),
          activetypename: button.data('activetypename'),
        }
      })

      $('#modalUnlinkActiveModelAndSimcard').on('hide.bs.modal', function (event) {
        global.dataToUnlink = undefined
        global.$store.dispatch('active/cleanState')
        global.alert.show = false
      })

      $('#modalLoadLinked').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget)
        const modal = $(this)
        global.loadLinked(button.data('id'))
      })

      const queryParams = this.$route.query

      if (Object.keys(queryParams).length) {
        for (const param in queryParams) {
          const value = isNaN(parseInt(queryParams[param]))
            ? queryParams[param]
            : parseInt(queryParams[param])

          this.query[param] = value
        }

        $('#search').trigger('click')
      } else if (this.lastquery['actives']) {
        for (const [key, value] of Object.entries(this.lastquery['actives'])) {
          this.query[key] = value
        }
      }

      this.queryToUse = this.query

      $('#toolbar')
        .find('div:first')
        .append(`
          <button
            id="export"
            class="btn btn-secondary right"
            aria-expanded="true"
          >
            <i class="fas fa-file-excel"></i>
          </button>
        `)

      $('#export').on('click', function() {
        global.exportSpreadsheet()
      })
    } catch (error) {
      console.log('[ERROR-MOUNT-ACTIVE-LIST] => ', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('manufacturer/cleanState'),
    dispatch('activestype/cleanState'),
    dispatch('model/cleanState'),
    dispatch('garageaccredited/cleanState')
    dispatch('status/cleanState')
    dispatch('filtershistory/setQuery', { key: 'actives', query: this.query })
  }
}
</script>
